import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/biotimeAttendances`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeAttendances/${id}`, options)
        .then(response => {
            let attendance = jsona.deserialize(response.data);
            delete attendance.links;
            return attendance;
        });
}

function view(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeAttendances/${params.id}${params.include ? '?include=' + params.include : ''}`, options)
        .then(response => {
            let attendance = jsona.deserialize(response.data);
            delete attendance.links;
            return attendance;
        });
}

function getStatistics(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/biotimeAttendances/statistics`, options)
        .then(response => {
            return response.data.data || [];
        });
}

function getTodayStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/biotimeAttendances/today-stats`, options)
        .then(response => {
            return response.data.data || {};
        });
}

function processAttendances(payload) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/biotimeAttendances/process/record/manual`, payload, options)
        .then(response => {
            return response.data;
        });
}


export default {
    list,
    get,
    view,
    getStatistics,
    getTodayStats,
    processAttendances
};